import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface TextProps
  extends HTMLAttributes<HTMLParagraphElement>,
    CommonComponentProps {}

export function Text({ children, className, ...rest }: TextProps) {
  return (
    <p
      className={cx(
        "font-sans text-body font-normal text-foreground",
        className
      )}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </p>
  );
}
